import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "next_btn" }

import { reactive, watchEffect, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { getOneThingGuidTree, getGuideItemList, getOntThingList } from "@/config/request"
import { useStore } from "vuex"
import ModelList from "./model-list.vue"
import GuideItem from "./guide-item.vue"
import { AREA_ID } from "@/config/const"
import { ElMessage } from 'element-plus'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const store = useStore()

const query = route.query

const data = reactive({
    modelCode: query.modelCode,
    modelName: query.modelName,
    parentid: query.parentid,
    theme: query.theme,
    hangyeType_dictText: query.hangyeType_dictText,
    dataList: [],    // 一件事选择情形树状结构数据
    selectPid: '',   //  选中的值的pid,即上一层级的id
    selectId: '',    //  选中的值的id
    loopEnd: false, //  终止循环
    itemList: [],    //  根据情形选择结果查询出来的事项列表
    oneThingMessage: [],    //  办事指南信息
    unid: '',
    serviceCode: '',
    guideId: '',
    selectServiceCode: '',  //  选中的事项
    projectcode: query.projectcode
})

/**
 * 获取情形数据
 */
const getSituation = async () => {
    const params = {
        modelCode: data.modelCode
    }
    const res = await getOneThingGuidTree(params) as any
    if (res.code === 200) {
        data.dataList = res.result
    }
    formateDataList()
}

const toPath = (path: string, params: any) => {
    router.push({
        path: path,
        query: params
    })
}

/**
 * 修改data.dataList里面字段值 将不显示的节点status改为0
 * @param obj
 */
const formateDataList = () => {
    let obj = data.dataList as any
    let index = 0
    if (obj.length > 0) {
        obj.forEach((node: any) => {
            setStatus(node.children, index)
        })
    }
}

/**
 * 将传入的json值的每个节点status都设置为index, 用来控制model树结构的显示隐藏
 * @param obj
 */
const setStatus = (obj: any, index: number) => {
    obj.forEach((res: any) => {
        res.status = index
        if (res.children.length > 0) {
            setStatus(res.children, index)
        }
    })
}

/**
 * 根据传入的值找到对应节点,并设置相应节点显隐状态
 * @param modelValue
 */

const checkPid = (modelValue: any, array: any) => {
    if (data.loopEnd) {
        return false
    }
    if (array.length > 0) {
        array.forEach((node: any) => {
            if (node.id === modelValue.pid) {   //  找到父节点
                setStatus(node.children, 0)     //  将下面的子节点都置为隐藏
                node.children.forEach((res: any) => {
                    if (res.id === modelValue.id) {
                        res.status = 1      //  找到节点，status改为1
                        res.children.forEach((son: any) => {
                            son.status = 1  //  显示下一层级
                        })
                        data.loopEnd = true
                    }
                })
            } else {
                if (!data.loopEnd) {
                    checkPid(modelValue, node.children)
                }
            }
        })
    }
}

/**
 * 根据选择的情形查询对应事项
 */
const getGuideItem = async () => {
    let param = {
        areaCode: AREA_ID,
        serviceCode: data.serviceCode,
        modelCode: data.unid
    }
    data.itemList = []
    const res = await getGuideItemList(param) as any
    if (res.code === 200) {
        let newItemList = JSON.parse(res.result).result || []
        newItemList.length = newItemList.length - 1
        data.itemList = newItemList
    }
}

/**
 * 办事指南信息
 */
const getOntThing = async () => {
    let param = {
        modelCode: data.modelCode,
        isbig: '1',
    }
    const res = await getOntThingList(param) as any
    if (res.code === 200) {
        let rows = res.result.records[0] || []
        data.oneThingMessage = rows
        data.unid = rows.unid
    }
}

const guideDom = ref(null) as any

const nextOne = () => {
    let checkedItemList = []
    let showChecked = guideDom.value.showChecked()
    let showformatItemList = guideDom.value.showformatItemList()

    let itemListLength = showformatItemList.length
    for (let i = 0; i < itemListLength; i++) {
        if (showChecked[i].status) {
            checkedItemList.push(showformatItemList[i].data[0].serviceCode || '')
        }
    }
    data.selectServiceCode = checkedItemList.toString()

    if (checkedItemList.length == 0) {
        ElMessage({
            type: 'error',
            message: '您所选择的情形无对应事项,请重新选择'
        })
        return false
    }

    const params = {
        bigModeCode: data.modelCode,
        modelCode: data.modelCode,
        modelName: data.modelName,
        hangyeType_dictText: data.hangyeType_dictText,
        parentid: '1',
        areaCode: AREA_ID,
        unid: data.unid,
        guideId: data.guideId,
        selectServiceCode: data.selectServiceCode,
        AreaLogoType: '1', //区域是否选择标识
        theme: data.theme,
        projectcode: data.projectcode
    }
    console.log('跳转参数',params);

    toPath('./work-guide', params)
}

store.commit('setModelValue', [])    //  进入页面置为空
watchEffect(() => {
    let modelValue = store.state.modelValue
    data.loopEnd = false
    data.serviceCode = modelValue.serviceCode
    data.guideId = modelValue.id
    if (data.serviceCode) {
        getGuideItem()
    }else{
        data.itemList = []
    }
    checkPid(modelValue, data.dataList)
})

const init = () => {
    getSituation()
    getOntThing()
}
init()


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "t6_breadCream" }, [
      _createElementVNode("span", null, "首页"),
      _createTextVNode(),
      _createElementVNode("i", null, ">"),
      _createTextVNode(),
      _createElementVNode("span", null, "一件事"),
      _createTextVNode(),
      _createElementVNode("i", null, ">"),
      _createTextVNode(),
      _createElementVNode("span", null, "办理情形")
    ], -1)),
    _createElementVNode("div", null, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "t6_title_h2" }, "请选择业务情形", -1)),
      _createVNode(ModelList, {
        dataList: data.dataList
      }, null, 8, ["dataList"])
    ]),
    _createElementVNode("div", null, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "t6_title_h2" }, "引导事项名称", -1)),
      _createVNode(GuideItem, {
        itemList: data.itemList,
        ref_key: "guideDom",
        ref: guideDom
      }, null, 8, ["itemList"])
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_button, {
        onClick: nextOne,
        size: "large",
        color: "#4ACAB6",
        style: {"color":"#fff"}
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode("生成办事指南", -1)
        ]))]),
        _: 1
      })
    ])
  ]))
}
}

})